import { render, staticRenderFns } from "./switchdetail.vue?vue&type=template&id=61f455b5&"
import script from "./switchdetail.vue?vue&type=script&lang=ts&"
export * from "./switchdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "switchdetail.vue"
export default component.exports